import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Polyline, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const COL = ["#0D4B78", "#D1694A", "#2f855a", "#805ad5", "#b7791f", "#c53030", "#2b6cb0", "#97266d", "#285e61", "#744210", "#1a202c", "#553c9a"];

const Fit = ({ pts, visible }) => {
  const map = useMap();
  const key = pts.map((p) => p.join(",")).join("|");
  useEffect(() => { map.invalidateSize(); if (pts.length > 1) map.fitBounds(pts, { padding: [30, 30], maxZoom: 11 }); else if (pts.length === 1) map.setView(pts[0], 11); }, [key, visible]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

export const JourneyMap = ({ days, cat, active, allDays, setAllDays, visible }) => {
  const site = Object.fromEntries(cat.sites.filter((s) => s.kind !== "activity").map((s) => [s.id, s]));
  const shown = days.filter((d) => allDays || d.n === active).map((d) => ({ ...d, items: d.items.filter((x) => !x.request) }));
  return (
    <div className="space-y-2" data-testid="journey-map">
      <div className="flex items-center justify-between text-xs"><label className="flex items-center gap-2"><input type="checkbox" checked={allDays} onChange={(e) => setAllDays(e.target.checked)} data-testid="map-all-days" />Show every day</label>
        <span className="text-slate-500">Planning map: pins are approximate and lines are not driving routes.</span></div>
      <div className="h-[60vh] overflow-hidden rounded-xl border lg:h-[32rem]">
        <MapContainer center={[32.2, 35.3]} zoom={8} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
          <TileLayer attribution='Tiles &copy; <a href="https://www.esri.com">Esri</a> &mdash; Esri, HERE, Garmin, OpenStreetMap contributors' url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}" maxZoom={16} />
          <Fit visible={visible} pts={shown.flatMap((d) => d.items.filter((x) => x.type === "site" && site[x.site_id]).map((x) => [site[x.site_id].lat, site[x.site_id].lng]))} />
          {shown.map((d) => {
            const pts = d.items.filter((x) => x.type === "site" && site[x.site_id]).map((x) => site[x.site_id]);
            const c = COL[(d.n - 1) % COL.length];
            return [
              <Polyline key={`l${d.n}`} positions={pts.map((s) => [s.lat, s.lng])} pathOptions={{ color: c, weight: 2, dashArray: "4 6" }} />,
              ...pts.map((s, i) => <CircleMarker key={`${d.n}-${s.id}-${i}`} center={[s.lat, s.lng]} radius={8} pathOptions={{ color: "#fff", fillColor: c, fillOpacity: 0.95, weight: 2 }}><Tooltip>Day {d.n} · {i + 1}. {s.name}</Tooltip></CircleMarker>),
            ];
          })}
        </MapContainer>
      </div>
    </div>
  );
};
